module.exports = __webpack_public_path__ + "assets/b93.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b93.png
// module id = 686
// module chunks = 0